import { render, staticRenderFns } from "./bottom-bar-actions.vue?vue&type=template&id=5aa3a78a&scoped=true"
import script from "./bottom-bar-actions.vue?vue&type=script&lang=js"
export * from "./bottom-bar-actions.vue?vue&type=script&lang=js"
import style0 from "./bottom-bar-actions.vue?vue&type=style&index=0&id=5aa3a78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3a78a",
  null
  
)

export default component.exports